import { OrderMeta, Product } from '@diamond/shared/schema';
import { Static, Type } from '@sinclair/typebox';

export const SAP_FIELD_DEFINITIONS: {
  [key: string]: SAPDefinition;
} = {
  AUART: {
    definition: 'Order Type',
    example: 'ZOR [Standard Order], ZVCS [Canvas Order]',
    type: 'CHAR',
  },
  KUNNR: {
    definition: 'Customer ID (sold-to), without leading zero',
    example: '10156356',
    type: 'CHAR',
  },
  VTWEG: {
    definition: 'Distribution Channel',
    example: 'DA [Jakarta], DF [Cimahi]',
    type: 'CHAR',
  },
  MATNR: {
    definition: 'Material Number',
    example: '10000011',
    type: 'CHAR',
  },
  BWTAR: {
    definition: 'Valuation Type',
    example: '',
    type: 'CHAR',
  },
  LFIMG: {
    definition: 'Quantity',
    example: '5',
    type: 'FLOAT',
  },
  VRKME: {
    definition: 'Sales Unit',
    example: 'PCS',
    type: 'CHAR',
  },
  NETWR: {
    definition: 'Price per Sales Unit',
    example: '100000',
    type: 'FLOAT',
  },
  WAERK: {
    definition: 'Currency',
    example: 'IDR',
    type: 'CHAR',
  },
  ERDAT: {
    definition: 'Data Collection Date [YYYYMMDD]',
    example: '20221214',
    type: 'DATE',
  },
  ANGKU: {
    definition: 'Freight Cost, if any, will increase the selling price',
    example: '1000',
    type: 'FLOAT',
  },
  CONTR: {
    definition:
      'Contract Price, just a flag if it was a contract price between SKD and customer',
    example: '[blank] or X',
    type: 'CHARBOOL',
  },
  PLUK: {
    definition: 'Pricing source',
    example: 'PLK or PLU',
    type: 'CHAR',
  },
  DATBI: {
    definition: 'Valid Until [YYYYMMDD]',
    example: '20221231',
    type: 'DATE',
  },
  VRKMX: {
    definition: 'ignore ~',
    example: '',
    type: 'CHAR',
  },
  WERKS: {
    definition: 'plant',
    example: '3113',
    type: 'CHAR',
  },
  LGORT: {
    definition: 'storage location',
    example: 'TG01',
    type: 'CHAR',
  },
  MENGE: {
    definition: 'Quantity -- for stock checkout',
    example: '201.070',
    type: 'FLOAT',
  },
  MEINS: {
    definition: 'sales UoM',
    example: 'KG',
    type: 'CHAR',
  },
  VKORG: {
    definition: 'Sales organization',
    example: '3000',
    type: 'CHAR',
  },
  SPART: {
    definition: 'division',
    example: 'DIA, TR, FF, EQ',
    type: 'CHARDIVISION',
  },
  BSTNK: {
    definition: 'PO reference number (SOL transaction number)',
    example: 'SOL_202212xxxxxx',
    type: 'CHAR',
  },
  POSNR: {
    definition: 'Line items, multiples of 10',
    example: '000010, 000020',
    type: 'FLOATZEROPADDED_6',
  },
  KWMENG: {
    definition: 'quantity -- for order transaction',
    example: '5',
    type: 'FLOAT',
  },
  KBETR: {
    definition:
      'Override Price, this will override price on this transaction only',
    example: '90000',
    type: 'FLOAT',
  },
  PRSDT: {
    definition: 'Pricing date when customer order',
    example: '',
    type: 'DATE',
  },
  VBELN: {
    definition: 'SAP Sales Document Number',
    example: '3710688432',
    type: 'CHAR',
  },
  ZTERM: {
    definition: 'Terms of payment key',
    example: 'ZF02',
    type: 'CHAR',
  },
  ERZET: {
    definition: 'Entry Time',
    example: '152358',
    type: 'TIME',
  },
  KDKG1: {
    definition: 'Condition group 1',
    example: '',
    type: 'CHAR',
  },
  GBSTK: {
    definition: 'Overall Status',
    example: 'Not yet processed',
    type: 'CHAR',
  },
  ABSTK: {
    definition: 'Rejection Status',
    example: 'Nothing Rejected',
    type: 'CHAR',
  },
  LFSTK: {
    definition: 'Delivery Status',
    example: 'Not Delivered',
    type: 'CHAR',
  },
  MESSG: {
    definition: 'Message, if any error received from SAP, it will show here',
    example: '',
    type: 'CHAR',
  },
  BSTKD: {
    definition: 'Message, if any error received from SAP, it will show here',
    example: '',
    type: 'FLOATZEROPADDED_6',
  },
  GBSTA: {
    definition: 'Overall Processing Status of the SD Document Item',
    example: 'A',
    type: 'CHAR',
  },
  KBMENG: {
    definition: 'Overall Processing Status of the SD Document Item',
    example: '0.0',
    type: 'FLOAT',
  },
  KNUMH: {
    definition: 'Price ID or Promo Code',
    example: '0007330442',
    type: 'CHAR',
  },
  KOLNR: {
    definition: 'Pricing priority order; lower values have higher priority',
    example: '180',
    type: 'NUM',
  },
  KSCHL: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KNRPOS: {
    definition: 'Promo Scaling for Free Good',
    example: '1',
    type: 'INT',
  },
  KNRMM: {
    definition: 'Promo Minimum Quantity',
    example: '1',
    type: 'FLOAT',
  },
  KNRME: {
    definition: 'Promo Unit of Measurement',
    example: 'CAN',
    type: 'CHAR',
  },
  KNRZM: {
    definition: 'Promo Free Good Quantity',
    example: '1',
    type: 'FLOAT',
  },

  // TODO: fill definition and example for SAP type below
  KNREZ: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KNRMAT: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KNRDD: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  VALFR: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'DATE',
  },
  VALTO: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'DATE',
  },
  KDKG2: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KDKG3: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KATR6: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KATR8: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KATR9: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  MATKL: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  MTART: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  MINQTY: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'FLOAT',
  },
  MINAMO: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'FLOAT',
  },
  MINAMT: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'FLOAT',
  },
  SUMMINQTY: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'FLOAT',
  },
  SUMMINAMO: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'FLOAT',
  },
  SUMMINAMT: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'FLOAT',
  },
  PRORT: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KONWA: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KPEIN: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KDKG4: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KATR1: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  KATR2: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  ZCALCNUM: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'INT',
  },
  KMEIN: {
    definition: 'Promo Condition Type',
    example: '',
    type: 'CHAR',
  },
  ZVOU: {
    definition:
      'Voucher code reference for order creation (format: namaVoucher + sequence)',
    example: 'VCHR-0001-1',
    type: 'CHAR',
  },
  AUTO_DO: {
    definition: 'Automatic Delivery Order flag',
    example: 'X',
    type: 'CHAR',
  },
  VBELN_VL: {
    definition: 'Delivery Document Number',
    example: '80000012',
    type: 'CHAR',
  },
  VBELN_VL2: {
    definition: 'Delivery Document Number',
    example: '80000012',
    type: 'CHAR',
  },
  VBELN_VL3: {
    definition: 'Delivery Document Number',
    example: '80000012',
    type: 'CHAR',
  },
  VBELN_VL4: {
    definition: 'Delivery Document Number',
    example: '80000012',
    type: 'CHAR',
  },
  MESSG_VL: {
    definition: 'Message for Delivery Document',
    example: 'Success',
    type: 'CHAR',
  },
  MESSG_VL2: {
    definition: 'Message for Delivery Document',
    example: 'Success',
    type: 'CHAR',
  },
  MESSG_VL3: {
    definition: 'Message for Delivery Document',
    example: 'Success',
    type: 'CHAR',
  },
  MESSG_VL4: {
    definition: 'Message for Delivery Document',
    example: 'Success',
    type: 'CHAR',
  },

  // ZFM_SD_FLOW_DATA
  GBSTX: {
    definition: 'Overall Status',
    example: 'Completely processed',
    type: 'CHAR',
  },
  ABSTX: {
    definition: 'Rejection Status',
    example: 'Nothing Rejected',
    type: 'CHAR',
  },
  LFSTX: {
    definition: 'Delivery Status',
    example: 'Fully Delivered',
    type: 'CHAR',
  },
  VDATU: {
    definition: 'Requested Delivery Date',
    example: '20260331',
    type: 'DATE',
  },
  ZPESO: {
    definition: 'Ordered By',
    example: 'Customer',
    type: 'CHAR',
  },
  LFCOD: {
    definition: 'B2B ID',
    example: 'B2B-0001',
    type: 'CHAR',
  },
  KUNB2: {
    definition: 'B2B Customer ID',
    example: '10066030',
    type: 'CHAR',
  },
  BEZEI: {
    definition: 'Description',
    example: 'Product description',
    type: 'CHAR',
  },
  MATB2: {
    definition: 'B2B Material',
    example: '100000796',
    type: 'CHAR',
  },
  MEIB2: {
    definition: 'B2B Unit of Measure',
    example: 'CAR',
    type: 'CHAR',
  },
  HGSAT: {
    definition: 'Unit Price',
    example: '60540.54',
    type: 'FLOAT',
  },
  DISCO: {
    definition: 'Discount',
    example: '0.00',
    type: 'FLOAT',
  },
  SUBTO: {
    definition: 'Subtotal',
    example: '242162.00',
    type: 'FLOAT',
  },
  PPN: {
    definition: 'Tax',
    example: '26638.00',
    type: 'FLOAT',
  },
  PPNFR: {
    definition: 'Tax Free',
    example: '0.00',
    type: 'FLOAT',
  },
  LFDAT: {
    definition: 'Delivery Date',
    example: '20260331',
    type: 'DATE',
  },
  NAME1: {
    definition: 'Name 1',
    example: 'Customer Name',
    type: 'CHAR',
  },
  STRAS: {
    definition: 'Street and House Number',
    example: 'Customer address',
    type: 'CHAR',
  },
  KOSTK: {
    definition: 'Picking Status',
    example: 'C',
    type: 'CHAR',
  },
  TRSTA: {
    definition: 'Transportation Planning Status',
    example: 'C',
    type: 'CHAR',
  },
  WBSTK: {
    definition: 'Goods Movement Status',
    example: 'C',
    type: 'CHAR',
  },
  FKSTK: {
    definition: 'Delivery-Related Billing Status',
    example: 'C',
    type: 'CHAR',
  },
  PDSTK: {
    definition: 'POD Status on Header Level',
    example: 'C',
    type: 'CHAR',
  },
  VGBEL: {
    definition: 'Reference Document Number',
    example: '1010281067',
    type: 'CHAR',
  },
  WADAT_IST: {
    definition: 'Actual Goods Movement Date',
    example: '20260330',
    type: 'DATE',
  },
  SPE_WAUHR_IST: {
    definition: 'Actual Goods Issue Time',
    example: '113100',
    type: 'TIME',
  },
  PODAT: {
    definition: 'Proof of Delivery Date',
    example: '20260417',
    type: 'DATE',
  },
  POTIM: {
    definition: 'Proof of Delivery Time',
    example: '141530',
    type: 'TIME',
  },
  QDATU: {
    definition: 'Confirmation Date',
    example: '20260330',
    type: 'DATE',
  },
  QZEIT: {
    definition: 'Confirmation Time',
    example: '112946',
    type: 'TIME',
  },
  VLCOM: {
    definition: 'Delivery Complete',
    example: 'X',
    type: 'CHAR',
  },
  LIFSK: {
    definition: 'Delivery Block',
    example: 'C',
    type: 'CHAR',
  },
  VGPOS: {
    definition: 'Reference Item Number',
    example: '000010',
    type: 'FLOATZEROPADDED_6',
  },
  GTEXT: {
    definition: 'POD Reason',
    example: 'SLS - STOCK MASIH BANYAK',
    type: 'CHAR',
  },
  WERTX: {
    definition: 'Plant Description',
    example: 'SKD ANCOL',
    type: 'CHAR',
  },
  LFIMG_DIFF: {
    definition: 'Quantity Difference',
    example: '2.000',
    type: 'FLOAT',
  },
  TKNUM: {
    definition: 'Shipment Number',
    example: '3000742530',
    type: 'CHAR',
  },
  DATBG: {
    definition: 'Shipment Start Date',
    example: '20260330',
    type: 'DATE',
  },
  UATBG: {
    definition: 'Shipment Start Time',
    example: '000000',
    type: 'TIME',
  },
  AUBEL: {
    definition: 'Sales Document',
    example: '1010281067',
    type: 'CHAR',
  },
  FKDAT: {
    definition: 'Billing Date',
    example: '20260417',
    type: 'DATE',
  },
  KUNRG: {
    definition: 'Payer',
    example: '10066030',
    type: 'CHAR',
  },
  MWSBK: {
    definition: 'Tax Amount in Document Currency',
    example: '92016.00',
    type: 'FLOAT',
  },
  KUNAG: {
    definition: 'Sold-to Party',
    example: '10066030',
    type: 'CHAR',
  },
  FKSTO: {
    definition: 'Billing Document Canceled',
    example: 'X',
    type: 'CHAR',
  },
  KNUMV: {
    definition: 'Document Condition Number',
    example: '0025468738',
    type: 'CHAR',
  },
  FKIMG: {
    definition: 'Actual Billed Quantity',
    example: '2.000',
    type: 'FLOAT',
  },
};

export const SAP_RFC_DEFINITIONS = {
  pricingCheckout: 'ZFM_SD_PEPPERI_SO_PRICINGX', // DEPRECATED
  pricingGlobal: 'ZFM_SD_PRICING_GLOBAL',
  stockCheckout: 'ZFM_SD_STOCK_UPDATE',
  createOrder: 'ZFM_SD_PEPPERI_SO_CREATE2',
  checkPromoDiscount: 'ZFM_SD_PEPPERI_SO_DISCOUNT',
  checkPromoFreeGoods: 'ZFM_SD_PEPPERI_SO_FGOODS',
  saveVoucher: 'ZFM_SD_PEPPERI_SAVE_VOUCHER',
  flowData: 'ZFM_SD_FLOW_DATA',
} as const;
export type SAP_RFC_DEFINITIONS =
  (typeof SAP_RFC_DEFINITIONS)[keyof typeof SAP_RFC_DEFINITIONS];

export const SAPField = Type.Union(
  Object.keys(SAP_FIELD_DEFINITIONS).map((t) => Type.Literal(t))
);
export type SAPField = Static<typeof SAPField>;

export const SAPDataType = Type.Union([
  Type.Literal('CHAR'),
  Type.Literal('CHARBOOL'), // custom, not really from SAP
  Type.Literal('FLOATZEROPADDED_6'), // custom, not really from SAP
  Type.Literal('CHARDIVISION'), // custom, not really from SAP
  Type.Literal('FLOAT'),
  Type.Literal('NUM'),
  Type.Literal('DATE'),
  Type.Literal('TIME'),
  Type.Literal('INT'),
]);
export type SAPDataType = Static<typeof SAPDataType>;

export const SAPDefinition = Type.Object({
  definition: Type.String(),
  example: Type.String(),
  type: SAPDataType,
});
export type SAPDefinition = Static<typeof SAPDefinition>;

// -----------------------
// Pricing (when checkout)
// -----------------------
export type PricingCheckoutResponse = {
  priceId: string;
  orderType: string;
  customerId: string;
  distributionChannel: string;
  materialNumber: string;
  valuationType: string;
  quantity: number;
  salesUnit: string;
  pricePerSalesUnit: number;
  currency: string;
  dataCollectionDate: Date;
  freightCost: number;
  contractPrice: boolean;
  validUntil: Date;
};

export type PricingCandidate = PricingCheckoutResponse & {
  priceSource: 'PLK' | 'PLU' | null;
  priceOrder: number | null;
};

// -----------------------
// Stock (when checkout)
// -----------------------
export type StockCheckoutResponse = {
  distributionChannel: string;
  plant: string;
  storageLocation: string;
  materialNumber: string;
  quantity: number;
  salesUOM: string;
};

// -----------------------
// Order Transaction ( Create Order Input & Response )
// -----------------------
export type OrderTransactionInputParams = {
  salesOrganization: string;
  distributionChannel: string;
  division: Static<typeof Product>['division'];
  customerId: string;
  SOLTransactionNumber: string;
  lineItem: number;
  materialNumber: string;
  quantity: number;
  salesUnit: string;
  orderType: string | null;
  valuationType?: string;
  overridePrice?: number;
  paymentMethod: Static<typeof OrderMeta>['payment_method'];
  deliveryNotes?: string;
  deliveryDate: string | null;
  pricingDate?: string;
  sapVoucherCode?: string;
};

export type DeliveryOrderNumber = {
  deliveryOrderNumber?: string;
  deliveryDocumentMessage?: string;
};

export type OrderTransactionResponseHeader = {
  SAPSalesDocumentNumber: string;
  customerNumber: string;
  SOLTransactionNumber: string;
  termsOfPaymentKey: string;
  createdAt: Date;
  conditionGroup1: string;
  overallStatus: string;
  rejectionStatus: string;
  deliveryStatus: string;
  deliveryOrderNumbers?: DeliveryOrderNumber[];
};

export type OrderTransactionResponseData = {
  SAPSalesDocumentNumber: string;
  SOLTransactionNumber: string;
  salesDocumentItem: string;
  lineItem: string;
  materialNumber: string;
  quantity: number;
  salesUnit: string;
  overallStatus: string;
  confirmedQuantity: number;
  plant: string;
};

// -----------------------
// Transaction ( Get Transaction from Webportal )
// -----------------------

export enum SAPStatus {
  NOT_YET_PROCESSED = 'Not Yet Processed',
  PARTIALLY_PROCESSED = 'Partially Processed',
  COMPLETELY_PROCESSED = 'Completely Processed',
  NOT_RELEVANT = 'Not Relevant',
}

export enum SAPOrderStatus {
  SUBMITTED = 'Submitted',
  RECEIVED = 'Received',
  PROCESS = 'Process',
  PROCESSED = 'Processed',
  DELIVERED = 'Not Relevant',
}

export enum SAPDeliveryStatus {
  NOT_DELIVERED = 'Not Delivered',
  PARTIALLY_DELIVERED = 'Partially Delivered',
  FULLY_DELIVERED = 'Fully Delivered',
  NOT_RELEVANT = 'Not Relevant',
}

export enum SAPRejectionStatus {
  NOTHING_REJECTED = 'Nothing Rejected',
  PARTIALLY_REJECTED = 'Partially Rejected',
  EVERYTHING_REJECTED = 'Everything Rejected',
  NOT_RELEVANT = 'Not Relevant',
}

export enum SAPStatusDescription {
  RECEIVED = 'Received',
  CANCELED = 'Canceled',
  DELIVERED = 'Delivered',
  DELIVERY_DOC = 'Delivery Doc',
  PARTIALLY_RECEIVED = 'Partially Received',
  OPEN = 'Open',
}
export interface HistoryTransactionDetail {
  PEPPERI_ORDER_NUMBER: string;
  SO_NUMBER: string;
  MATERIAL: string;
  NET_VALUE: string;
  ORDER_QTY: string;
  CONFIRM_QTY: string;
  DELIVERED_QTY: string;
  SALES_UNIT: string;
  PLANT: string;
  LINE_ITEM: string;
  LINE_PEPPERI: string;
  FLAG_STS: string;
  FLAG_PEPPERI: string;
  ISCOMMODITY: string;
  ORIGINALPRICE: string;
  CATEGORY2: string;
  LINE_SAP: string;
  MATERIAL_DESCRIPTION: string;
  LINE_REMARK: string;
  VALUATION_TYPE: string;
  ISOVERRIDEPRICE: string;
  ORIGINAL_VALUATION_TYPE: string;
  ISCONTRACTPRICE: string;
  QTY_CONFIRM_FR_SAP: string;
  CREATED_TIMESTAMP: string;
  ORDER_ID: string;
}

export interface HistoryTransaction {
  SHIPTO: string;
  TOP: string;
  ORDER_DATE: string;
  AGENT_ID: string;
  GRAND_TOTAL: string;
  ORDER_STATUS: string;
  SO_NUMBER: string;
  DATE_SAP: string;
  TIME_SAP: string;
  FLAG_STS: string;
  FLAG_PEPPERI: string;
  ISCOMMODITYCHECK: string;
  SAPSTATUS: SAPStatus;
  SAPREJSTATUS: SAPRejectionStatus;
  SAPDELSTATUS: SAPDeliveryStatus;
  STATUSDESCRIPTION: SAPStatusDescription;
  FLAG_INVOICE: string;
  TERM_OF_PAYMENT: string;
  TERM_OF_PAYMENT_DESC: string;
  ORDER_ID: string;
  TRANSACTION_ID: string;
  DELIVERYLINK: string;
  INVOICELINK: string;
  DETAIL: HistoryTransactionDetail[];
  ORDER_REMARKS: string;
  CUSTOMER_PO_NUMBER: string;
  DIVISION_CATALOG: SAPDivision;
  SCOPE: string;
  CREATE_ID: string;
  DATE_DOWNLOAD: string;
  TIME_DOWNLOAD: string;
  LINK_ORDER: string;
  FLAG_EMAIL: string;
  MODIFICATION_DATE: string;
  CATALOG_TYPE: string;
  CREATED_TIMESTAMP: string;
}

// -----------------------
// Delivery Order
// -----------------------
export interface DeliveryOrderHeader {
  DELIVERY_NUMBER: string;
  SHIP_TO_PARTY: string;
  PICKING_STATUS: string;
  SHIPMENT_STATUS: string;
  GOOD_MOVEMENT_STATUS: string;
  BILLING_STATUS: string;
  POD_STATUS: string;
  SO_NUMBER: string;
  DELIVERY_DATE: string;
  CUSTOMER_NAME: string;
  ADDRESS: string;
  CREATED_TIME: string;
  CREATED_ON: string;
  PGI_DATE: string;
  PGI_TIME: string;
  POD_DATE: string;
  POD_TIME: string;
  PICKING_DATE: string;
  PICKING_TIME: string;
  SHIPMENT_DATE: string;
  SHIPMENT_TIME: string;
  SHIPMENT_NO: string;
  FLAG_STS: string;
  BILLING_DATE: string;
  BILLING_TIME: string;
  BILLING_NO: string;
}

// -----------------------
// Material
// -----------------------
export type SAPDivision =
  | 'DIA'
  | 'TR'
  | 'FF'
  | 'EQ'
  | 'FINE FOOD'
  | 'EQUIPMENT'
  | 'TRADING';
export type SAPStorageCond = 'DR' | 'DA' | 'CH' | 'FZ';
export type SAPActiveStatus = 'N' | 'Y';

export type Material = {
  MATERIAL: number;
  MATERIAL_DESCRIPTION: string;
  MATERIAL_LONG_TEXT: string;
  MATERIAL_GROUP: string;
  MATERIAL_GROUP_DESC: string;
  PACK_SIZE_OLD: string;
  BASE_UNIT_MEASURE: string;
  BASE_UNIT_MEASURE_DESC: string;
  SALES_UNIT_DESC: string;
  DENOMINATOR_SALES_UNIT?: string;
  COUNTER_BASE_UNIT?: string;
  CONVERSION_SALES_UNIT: string;
  MATERIAL_TYPE: string;
  SIZE_DIMENSION: string;
  GROSS_WEIGHT: string;
  NET_WEIGHT: string;
  WEIGHT_UNIT: string;
  GROSS_WEIGHT_DESC: string;
  NET_WEIGHT_DESC: string;
  VOLUME: string;
  VOLUME_UNIT: string;
  VOLUME_DESC: string;
  STORAGE_COND: SAPStorageCond;
  STORAGE_COND_DESC: string;
  TRANSPORTATION_GROUP: string;
  EAN_UPC: string;
  PRODUCT_HIERARCHY_LVL1_CODE: string;
  PRODUCT_HIERARCHY_LVL1: string;
  PRODUCT_HIERARCHY_LVL2_CODE: string;
  PRODUCT_HIERARCHY_LVL2: string;
  PRODUCT_HIERARCHY_LVL3_CODE: string;
  PRODUCT_HIERARCHY_LVL3: string;
  MKT_CAT_3: SAPDivision;
  FIX_PRICE: string;
  CATEGORY_2: string;
  DIVISION: SAPDivision;
  TAG_ITEM: string;
  UNIT_DIMENSION: string;
  UNIT_DIMENSION_DESC: string;
  FLAG_SHOW_PEPPERI?: string;
  IS_VALID_DATA?: string;
  PACK_SIZE_SALES_UOM: string;
  PRODUCT_INFORMATION: string;
  KOMPOSISI: string;
  PRODUCT_EXCELLENCE: string;
  FLAG_FS?: string;
  FLAG_GT?: string;
  FI_CATEGORY_5: string;
  FI_CATEGORY_6: string;
  FI_CATEGORY_7: string;
  SALES_UNIT: string;
  FLAG_STS?: string;
  MINIMUM_ORDER_QTY: string;
  CASE_QTY: string;
  FLAG_MITRA_SUKANDA: string;
  FLAG_ONLINE_BISNIS: string;
  FLAG_AUTOMATED_SO: string;
  FLAG_AUTOMATED_DO?: string;
  SUGGESTION_1: string;
  SUGGESTION_2: string;
  CONVERSION_QTY: string;
  CONVERSION_UNIT: string;
  MIN_REMAINING_SHELF_LIFE: number;
  TOTAL_SHELF_LIFE: number;
  IND_SHELF_LIFE_EXP_DATE?: string;
  PRODUCT_GROUP?: string;
  ITEM_FOR_SPECIFIED_ACCOUNTONLY?: string;
};

// MATERIAL EXCLUDE BRANCH
// -----------------------
export type MaterialExcludeBranch = {
  MATERIAL: number;
  DISTRIBUTION_CHANNEL: string;
  PLANT: number;
  COND_GROUP_1_SHIPTO: string | null;
};

// MATERIAL EXCLUDE CUSTOMER
// -------------------------
export type MaterialExcludeCustomer = {
  SHIPTO: number;
  MATERIAL: number;
};

// -----------------------
// PLU
// -----------------------
export type PriceListUmum = {
  PRICE_ID: string;
  MATERIAL: number;
  DISTRIBUTION_CHANNEL: string;
  COND_GROUP_1: string;
  COND_GROUP_2?: string | null;
  COND_GROUP_3?: string | null;
  COND_GROUP_4: string;
  COND_GROUP_5: string;
  VALUATION_TYPE: string;
  PRICE_NUMBER: number;
  VALID_FROM: string;
  VALID_UNTIL: string;
  DATE_UPDATED: string;
  TIME_UPDATED: string;
  UOM?: string | null;
  PRICE_ORDER?: number | null;
};

// -----------------------
// PLK
// -----------------------
export type PriceListKhusus = {
  PRICE_ID: string;
  MATERIAL: number;
  CUSTOMER: number;
  DISTRIBUTION_CHANNEL: string;
  VALUATION_TYPE: string;
  PRICE_NUMBER: number;
  VALID_FROM: string;
  VALID_UNTIL: string;
  DATE_UPDATED: string;
  TIME_UPDATED: string;
};

// -----------------------
// Stock
// -----------------------
export type Stock = {
  MATERIAL: number;
  DISTRIBUTION_CHANNEL: string;
  PLANT: number;
  STORAGE_LOCATION: string;
  STOCK: number;
};

// -----------------------
// Stock Days
// -----------------------
export type StockDay = {
  MATERIAL: number;
  DISTRIBUTION_CHANNEL: string;
  PLANT: number;
  STORAGE_LOCATION: string;
  STOCK_DAYS: number;
};

// -----------------------
// BILTOS
// -----------------------
export type Biltos = {
  ID_KIL_BILTO: string;
  SEARCH_TERM_BILTO_2: string;
  CPY_TITLE_BILTO: string;
  LANG_BILTO: string;
  COMPANY_NAME_BILTO: string;
  FIRST_NAME_BILTO: string;
  ID_NO_BILTO: string;
  LAST_NAME_BILTO: string;
  TYPE_BILTO: string;
  DIV_BILTO: string;
  TELP_BILTO: string;
  TELP_BILTO2: string;
  TELP_BILTO3: string;
  HP_BILTO: string;
  HP_BILTO2: string;
  HP_BILTO3: string;
  FAX_BILTO: string;
  LM_ADDRESS1_BILTO: string;
  ADDRESS1_BILTO: string;
  ZIP_CODE_BILTO: string;
  CITY_BILTO: string;
  TIME_ZONE_BILTO: string;
  VAT_BILTO: string;
  ATRIBUT1_BILTO: string;
  ATRIBUT2_BILTO: string;
  DIST_CH_BILTO: string;
  SALES_ORG_BILTO: string;
  SALES_DISTRICT: string;
  CR_LIMIT_BILTO: string;
  TOP_BILTO: string;
  TAX_BILTO: string;
  CREATED_DATE: string;
  CREATED_BY: string;
  CREATOR_DIST_CH: string;
  DW_STS_BILTO: string;
  SAP_NO_BILTO: string;
  ORAC_NO_BILTO: string;
  REQ_STS_BILTO: string;
  REAS_BILTO: string;
  REJ_BY_BILTO: string;
  ACTIVE_BILTO: SAPActiveStatus;
  BLOCK_BILTO: SAPActiveStatus;
  MSTR_APPR_STS_BILTO: string;
  SC_COMPANY_NAME_BILTO: string;
  FLAG_COLL_SUBMIT: string;
  FLAG_DISTR_SUBMIT: string;
  ID_CRLIM_CR_DEPEDENCY: string;
  TIPE_ID: string;
  FIRST_NAME_SOL: string;
  LAST_NAME_SOL: string;
  EMAIL_SOL: string;
  FLAG_SOL: string;
  TELP_SOL: string;
  TOP_DESC: string;
  MID_NAME_BILTO: string;
  EMAIL_BILTO: string;
  DEPT_BILTO: string;
  FUNCTION_BILTO: string;
  ADDRESS2_BILTO: string;
  PROV_BILTO: string;
  DISTRICT_BILTO: string;
  VILLAGE_BILTO: string;
  FREEZER_BILTO: string;
  PAYMENT_METHOD_BILTO: string;
  ACC_NO_BILTO: string;
  ACC_NAME_BILTO: string;
  BANK_NAME_BILTO: string;
  ACC_BRANCH_BILTO: string;
  BANK_KEY_BILTO: string;
  MSTR_APPR_DATE_BILTO: string;
  MSTR_APPR_BY_BILTO: string;
  FINAL_APPR_TIME_BILTO: string;
  ACCT_APPR_TIME_BILTO: string;
  MSTR_APPR_TIME_BILTO: string;
  CREATED_TIME: string;
  ATRIBUT3_BILTO: string;
  NO_SPKP: string;
  FINAL_APPR_STS_BILTO: string;
  FINAL_APPR_DATE_BILTO: string;
  FINAL_APPR_BY_BILTO: string;
  ACCT_APPR_STS_BILTO: string;
  ACCT_APPR_DATE_BILTO: string;
  ACCT_APPR_BY_BILTO: string;
  FINAL_APPR_STS_OLB: string;
  FINAL_APPR_BY_OLB: string;
  FINAL_APPR_TIME_OLB: string;
  STOP_WARN: string;
  SFA: string;
  FINAL_APPR_DATE_OLB: string;
  CREATED_SOL: string;
  LAST_UPDATE: string;
  FLAG_DUMMY: SAPActiveStatus;
};

// PRODUCT VALUATION TYPE
// -----------------------
export type ValuationType = {
  MATERIAL: number;
  VALUATION_TYPE: string;
};

// SHIP TOS
// -----------------------
export type Shiptos = {
  ID_KIL_SHIPTO: string;
  ID_KIL_BILTO: string;
  SHIPTO_TYPE: string;
  CPY_TITLE_SHIPTO: string;
  COMPANY_NAME_SHIPTO: string;
  FIRST_NAME_SHIPTO: string;
  LAST_NAME_SHIPTO: string;
  SEARCH_TERM_SHIPTO: string;
  SEARCH_TERM_SHIPTO_2: string;
  DIV_SHIPTO: string;
  TELP_SHIPTO: string;
  TELP_SHIPTO2: string;
  TELP_SHIPTO3: string;
  HP_SHIPTO: string;
  HP_SHIPTO2: string;
  HP_SHIPTO3: string;
  EMAIL_SHIPTO: string;
  LM_ADDRESS1_SHIPTO: string;
  ADDRESS1_SHIPTO: string;
  ADDRESS2_SHIPTO: string;
  PROV_SHIPTO: string;
  DISTRICT_SHIPTO: string;
  COUNTRY_SHIPTO: string;
  ZIP_CODE_SHIPTO: string;
  CITY_SHIPTO: string;
  VILLAGE_SHIPTO: string;
  BILLING_ADDRESS: string;
  SALESMAN_SHIPTO_TRD: string;
  SALES_ID_SHIPTO_TRD: string;
  SPV_SALESMAN_SHIPTO_TRD: string;
  SPV_SALES_ID_SHIPTO_TRD: string;
  SOF_SHIPTO: string;
  TAX_SHIPTO: string;
  DELIV_PLANT_SHIPTO: string;
  DIST_CH_SHIPTO: string;
  DESC_DIST_CH: string;
  SALES_ORG_SHIPTO: string;
  COND_GROUP_3_SHIPTO: string;
  COND_GROUP_2_SHIPTO: string;
  COND_GROUP_1_SHIPTO: string;
  COND_GROUP_4: string;
  COND_GROUP_5: string;
  DESC_COND_1: string;
  DESC_COND_2: string;
  DESC_COND_3: string;
  DESC_COND_4: string;
  DESC_COND_5: string;
  SALES_DISTRICT_SHIPTO: string;
  ATRIBUT2_SHIPTO: string;
  KAM_CODE_DIA_SHIPTO: string;
  KAM_CODE_TRD_SHIPTO: string;
  KAE_CODE_DIA_SHIPTO: string;
  KAE_CODE_TRD_SHIPTO: string;
  TIME_ZONE_SHIPTO: string;
  TRANZ_ZONE_SHIPTO: string;
  PRIORITY_SHIPTO: string;
  FREEZER_BILTO: string;
  POD_SHIPTO: string;
  COL_SHIPTO: string;
  CREATED_DATE: string;
  CREATED_DATE_TIME: string;
  CREATED_BY: string;
  CREATOR_DIST_CH: string;
  DELIV_DATE_SHIPTO: string;
  LONG_SHIPTO: string;
  LAT_SHIPTO: string;
  PIC_COL_SHIPTO: string;
  HP_PIC_COL_SHIPTO: string;
  COLL_DAY_SHIPTO1: string;
  COLL_DAY_SHIPTO2: string;
  COLL_DAY_SHIPTO3: string;
  COLL_DAY_SHIPTO5: string;
  COLL_DAY_SHIPTO6: string;
  DW_STS_SHIPTO: string;
  SAP_NO_SHIPTO: string;
  ORAC_NO_SHIPTO: string;
  REQ_STS_SHIPTO: string;
  REAS_SHIPTO: string;
  REJ_BY_SHIPTO: string;
  CHANGED_TYPE_SHIPTO: string;
  ACTIVE_SHIPTO: SAPActiveStatus;
  KODE_SALES_FS_TRD: string;
  ID_SALES_FS_TRD: string;
  KODE_SPV_SALES_FS_TRD: string;
  ID_SPV_SALES_FS_TRD: string;
  KODE_PRICELIST_FS_TRD: string;
  KODE_SALES_FS_DIA: string;
  ID_SALES_FS_DIA: string;
  KODE_SPV_SALES_FS_DIA: string;
  ID_SPV_SALES_FS_DIA: string;
  KODE_PRICELIST_FS_DIA: string;
  MSTR_APPR_STS_SHIPTO: string;
  SAME_AS_BILTO: string;
  SC_COMPANY_NAME_SHIPTO: string;
  BLOCK_SHIPTO: SAPActiveStatus;
  FLAG_SHOW_PEPPERI: string;
  STOP_WARN_CREDIT_LIMIT: string;
  MESSAGE: string;
  FISCAL_ADDRESS: string;
  TFISCAL_ADDRESS: string;
  COLLECTOR_SHIPTO: string;
  FLAG_DUMMY: SAPActiveStatus;
  ATRIBUT9_SHIPTO: string;
  COLL_DAY_SHIPTO4: string;
  GROUPING_SHIPTO: string;
};

// CANCEL REASON
// -----------------------
export type CancelReasons = {
  REASON_ID: string;
  REASON: string;
  REASON_TYPE: string;
  REASON_STATUS: string;
};

// PROMO
// -----------------------
export type Discount = {
  AUART: string;
  VKORG: string;
  KATR8: string;
  MATNR: string;
  KSCHL: string;
  NETWR: string;
  KONWA: string;
  KPEIN: string;
  VALFR: string;
  VALTO: string;
  ERDAT: string;
  KNUMH: string;
  KUNNR: string;
  VTWEG: string;
  KDKG1: string;
  KDKG2: string;
  KDKG3: string;
  KDKG4: string;
  KATR1: string;
  KATR2: string;
  KATR9: string;
  MATKL: string;
  MTART: string;
  MINQTY: string;
  MINAMT: string;
  SUMMINQTY: string;
  SUMMINAMT: string;
  ZCALCNUM: string;
  KMEIN: string;
  PRORATE: string;
  PRORT: string; // from rfc type
};

export type FreeGood = {
  ['AUART ']: string;
  AUART: string;
  KUNNR: string;
  VKORG: string;
  VTWEG: string;
  MATNR: string;
  KSCHL: string;
  KNRPOS: string;
  KNRMM: string;
  KNRME: string;
  KNRZM: string;
  KNREZ: string;
  KNRMAT: string;
  KNRDD: string;
  VALFR: string;
  VALTO: string;
  ERDAT: string;
  KNUMH: string;
  KDKG1: string;
  KDKG2: string;
  KDKG3: string;
  KATR6: string;
  KATR8: string;
  KATR9: string;
  MATKL: string;
  MTART: string;
  MINQTY: string;
  MINAMO: string;
  MINAMT: string;
  SUMMINQTY: string;
  SUMMINAMO: string;
  SUMMINAMT: string;
  PRORT: string;
};

export type FreeGoodGroup = {
  VKORG: string;
  KDKG1: string;
  MINQTY: string;
  MINAMO: string;
  SUMMINQTY: string;
  SUMMINAMO: string;
  MATKL: string;
  KNRPOS: string;
  KNRMM: string;
  KNRME: string;
  KNRZM: string;
  KNREZ: string;
  VALFR: string;
  VALTO: string;
  PRORT: string;
  GROUP_ID: string;
  PROMO: string[];
};

export type DiscountGroup = {
  VKORG: string;
  KDKG1: string;
  MINQTY: string;
  MINAMT: string;
  SUMMINQTY: string;
  SUMMINAMT: string;
  MATKL: string;
  NETWR: string;
  KONWA: string;
  KPEIN: string;
  VALFR: string;
  VALTO: string;
  PRORATE: string;
  GROUP_ID: string;
  PROMO: string[];
};

// -----------------------
// Webportal
// -----------------------
export type AddDefaultField<T> = {
  status: number | string | boolean;
  error: string;
} & T;

export type Pagination<T> = {
  data: T[];
  page: number;
  limit: number;
  records: string;
  max_page: number;
};

export type LoginResponse = {
  access_token: string;
  expire_in: number;
};

export type OmitTableDefault<T> = Omit<
  T,
  | 'id'
  | 'is_new_product'
  | 'created_at'
  | 'created_by'
  | 'updated_at'
  | 'updated_by'
  | 'deleted_at'
  | 'deleted_by'
>;

export const imageMIME = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  ico: 'image/x-icon',
} as const;
export type MIMEType = (typeof imageMIME)[keyof typeof imageMIME];

// -----------------------
// SD Flow Data (ZFM_SD_FLOW_DATA)
// -----------------------
export interface SdFlowSoHeader {
  salesOrderNumber: string;
  overallStatus: string;
  rejectionStatus: string;
  deliveryStatus: string;
  requestedDeliveryDate: string | null;
  orderedBy: string;
  customerReference: string;
  createdDate: string | null;
  createdTime: string | null;
  b2bId: string;
  b2bCustomerId: string;
  salesDocumentType: string;
  salesOrganization: string;
  voucherCode: string;
}

export interface SdFlowSoLine {
  salesOrderNumber: string;
  lineItem: string;
  materialNumber: string;
  netValue: number;
  description: string;
  deliveredQuantity: number;
  salesUnit: string;
  b2bMaterial: string;
  b2bUnit: string;
  materialGroup: string;
  unitPrice: number;
  discount: number;
  subtotal: number;
  tax: number;
  taxFree: number;
  currency: string;
  salesUnitText: string;
}

export interface SdFlowDoHeader {
  deliveryNumber: string;
  deliveryDate: string | null;
  customerNumber: string;
  customerName: string;
  address: string;
  pickingStatus: string;
  transportStatus: string;
  goodsMovementStatus: string;
  billingStatus: string;
  podStatus: string;
  referenceSalesOrderNumber: string;
  createdDate: string | null;
  createdTime: string | null;
  goodsIssueDate: string | null;
  goodsIssueTime: string | null;
  podDate: string | null;
  podTime: string | null;
  confirmationDate: string | null;
  confirmationTime: string | null;
  deliveryComplete: string;
  deliveryBlock: string;
}

export interface SdFlowDoLine {
  deliveryNumber: string;
  lineItem: string;
  materialNumber: string;
  deliveredQuantity: number;
  salesUnit: string;
  referenceSalesOrderNumber: string;
  referenceLineItem: string;
  receivedQuantity: number;
  podReason: string;
  plant: string;
  plantName: string;
  salesUnitText: string;
}

export interface SdFlowShipment {
  shipmentNumber: string;
  deliveryNumber: string;
  startDate: string | null;
  startTime: string | null;
}

export interface SdFlowInvoiceHeader {
  salesOrderNumber: string;
  customerReference: string;
  referenceDeliveryNumber: string;
  invoiceNumber: string;
  invoiceDate: string | null;
  payerNumber: string;
  customerName: string;
  netValue: number;
  taxAmount: number;
  createdDate: string | null;
  createdTime: string | null;
  soldToNumber: string;
  orderedBy: string;
  isCanceled: boolean;
  currency: string;
}

export interface SdFlowInvoiceLine {
  invoiceNumber: string;
  lineItem: string;
  conditionNumber: string;
  billedQuantity: number;
  salesUnit: string;
  netValue: number;
  taxAmount: number;
  salesUnitText: string;
  currency: string;
}

export interface SdFlowFlatResponse {
  soHeaders: SdFlowSoHeader[];
  soLines: SdFlowSoLine[];
  doHeaders: SdFlowDoHeader[];
  doLines: SdFlowDoLine[];
  shipments: SdFlowShipment[];
  invoiceHeaders: SdFlowInvoiceHeader[];
  invoiceLines: SdFlowInvoiceLine[];
}

export interface SdFlowInvoice {
  header: SdFlowInvoiceHeader;
  lines: SdFlowInvoiceLine[];
}

export interface SdFlowDeliveryOrder {
  header: SdFlowDoHeader;
  lines: SdFlowDoLine[];
}

export interface SdFlowSalesOrder {
  salesOrderNumber: string;
  header: SdFlowSoHeader;
  lines: SdFlowSoLine[];
  deliveryOrders: SdFlowDeliveryOrder[];
  invoices: SdFlowInvoice[];
  shipments: SdFlowShipment[];
}
